import { createGenericTypes, createGenericActions } from "utils/createAction";

export const getTagsTypes = createGenericTypes("GET_TAGS");
export const getTagsActions = createGenericActions(getTagsTypes);
